export const close = (items) => {
  window.location = `/app/exercise/action/close`;
}
